import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSharedGlobalState } from '@core/rc-state';
/**
 * /purchase/materialStock/create -> /purchase/materialStock -> /purchase
 *  递归变量菜单,匹配当前路由
 * @param resourceListAllIdKeyMap
 * @param pathname
 * @returns
 */
const eachMatch = (resourceListAllIdKeyMap, pathname = '') => {
    if (resourceListAllIdKeyMap[pathname]) {
        return resourceListAllIdKeyMap[pathname];
    }
    else if (!pathname || pathname == '/') {
        return null;
    }
    else {
        const pathArr = pathname.split('/').filter(Boolean);
        return eachMatch(resourceListAllIdKeyMap, '/' + pathArr.splice(0, pathArr.length - 1).join('/'));
    }
};
/**
 * 根据当前url,匹配到当前路由,对应的接口菜单数据
 * @returns
 */
export const useMatchMenuItem = () => {
    const { resourceListMap, resourceList = [] } = useSharedGlobalState();
    const location = useLocation();
    const matchMenuItem = useMemo(() => {
        const pathname = location.pathname.replace(/\/$/, '');
        if (!pathname || pathname == '/') {
            return resourceList[0];
        }
        const matchInfo = eachMatch(resourceListMap, pathname);
        if (matchInfo) {
            return matchInfo;
        }
        // 兼容就旧外链功能，直接取菜单id当路由
        return eachMatch(resourceListMap, pathname.replace('/', ''));
    }, [location, resourceList, resourceListMap]);
    return matchMenuItem;
};
